import * as React from 'react';
import { campaignSectionInitialState } from './campaignSectionInitialState';
import { campaignSectionReducer } from './campaignSectionReducer';
import { CampaignSectionDispatch, CampaignSectionState } from './OnsiteCampaignSectionState';

const CampaignSectionContext = React.createContext<
  { state: CampaignSectionState; dispatch: CampaignSectionDispatch } | undefined
>(undefined);

function useCampaignSectionContext() {
  const context = React.useContext(CampaignSectionContext);
  if (!context) {
    throw new Error(`useCampaignSectionContext must be used within a CampaignSectionProvider`);
  }
  return context;
}

function CampaignSectionProvider(props) {
  const [state, dispatch] = React.useReducer(campaignSectionReducer, campaignSectionInitialState);
  const value = { state, dispatch };
  return <CampaignSectionContext.Provider value={value} {...props} />;
}

export { CampaignSectionProvider, useCampaignSectionContext };
